import { useState } from "react";
import { NewAptSelectTagsUi } from "ui";
import useGetQueueConfig from "../../../apis/tryst/get-queue-config";
import TagsPopup from "../../../molecules/cards/queue/tags-popup";
import { TagRecord } from "@elixir/types";

type TNewAptSelectedTagsProps = {
  selectedTags: Array<TagRecord["tag_id"]>;
  handleTagClick: (selectedTagId: TagRecord["tag_id"]) => void;
};

const NewAptSelectedTags = ({
  selectedTags,
  handleTagClick,
}: TNewAptSelectedTagsProps) => {
  const { data: queueConfigData } = useGetQueueConfig();
  const { tags = [] } = queueConfigData?.data || {};
  const [tagsOpen, setTagsOpen] = useState<boolean>(false);

  return (
    <NewAptSelectTagsUi
      showTagsPopup={tagsOpen}
      setShowTagsPopup={setTagsOpen}
      tags={tags}
      selectedTags={selectedTags}
      onTagClick={handleTagClick}
      TagpopupContent={
        <TagsPopup
          onTagSelect={handleTagClick}
          tags={tags}
          selectedTags={selectedTags}
          onClose={() => setTagsOpen(false)}
        />
      }
    />
  );
};

export default NewAptSelectedTags;
